"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initiateDatum1D = void 0;
const uuid_1 = require("@lukeed/uuid");
const nmr_processing_1 = require("nmr-processing");
const convertDataToFloat64Array_1 = require("./convertDataToFloat64Array");
const get1DColor_1 = require("./get1DColor");
const initiateIntegrals_1 = require("./integrals/initiateIntegrals");
const initiatePeaks_1 = require("./peaks/initiatePeaks");
const initiateRanges_1 = require("./ranges/initiateRanges");
const SumManager_1 = require("./SumManager");
function initiateDatum1D(spectrum, options = {}) {
    const { usedColors = {}, filters = [], molecules = [] } = options;
    const { integrals, ranges, ...restSpectrum } = spectrum;
    const spectrumObj = { ...restSpectrum };
    spectrumObj.id = spectrum.id || (0, uuid_1.v4)();
    spectrumObj.display = {
        isVisible: true,
        isRealSpectrumVisible: true,
        ...spectrum.display,
        ...(0, get1DColor_1.get1DColor)(spectrum, usedColors),
    };
    spectrumObj.info = {
        nucleus: '1H',
        isFid: false,
        isComplex: false,
        dimension: 1,
        ...spectrum.info,
    };
    spectrumObj.originalInfo = spectrumObj.info;
    spectrumObj.meta = { ...spectrum.meta };
    spectrumObj.customInfo = { ...spectrum.customInfo };
    spectrumObj.data = (0, convertDataToFloat64Array_1.convertDataToFloat64Array)(spectrum.data);
    spectrumObj.originalData = spectrumObj.data;
    spectrumObj.filters = Object.assign([], spectrum.filters); //array of object {name: "FilterName", options: FilterOptions = {value | object} }
    const { nucleus } = spectrumObj.info;
    spectrumObj.peaks = (0, initiatePeaks_1.initiatePeaks)(spectrum, spectrumObj);
    // array of object {index: xIndex, xShift}
    // in case the peak does not exactly correspond to the point value
    // we can think about a second attributed `xShift`
    const integralsOptions = (0, SumManager_1.initSumOptions)(integrals?.options || {}, {
        nucleus,
        molecules,
    });
    spectrumObj.integrals = (0, initiateIntegrals_1.initiateIntegrals)(spectrum, spectrumObj, integralsOptions); // array of object (from: xIndex, to: xIndex)
    const rangesOptions = (0, SumManager_1.initSumOptions)(ranges?.options || {}, {
        nucleus,
        molecules,
    });
    spectrumObj.ranges = (0, initiateRanges_1.initiateRanges)(spectrum, spectrumObj, rangesOptions);
    //reapply filters after load the original data
    nmr_processing_1.FiltersManager.reapplyFilters(spectrumObj);
    preprocessing(spectrumObj, filters);
    return spectrumObj;
}
exports.initiateDatum1D = initiateDatum1D;
function preprocessing(datum, onLoadFilters = []) {
    if (datum.info.isFid) {
        if (onLoadFilters?.length === 0) {
            nmr_processing_1.FiltersManager.applyFilter(datum, [
                {
                    name: nmr_processing_1.Filters.digitalFilter.id,
                    value: {},
                    isDeleteAllow: false,
                },
            ]);
        }
        else {
            const filters = [];
            for (let filter of onLoadFilters) {
                if ((!datum.info?.digitalFilter &&
                    filter.name === nmr_processing_1.Filters.digitalFilter.id) ||
                    !filter.flag) {
                    continue;
                }
                if (filter.name === nmr_processing_1.Filters.digitalFilter.id) {
                    filter = { ...filter, isDeleteAllow: false };
                }
                filters.push(filter);
            }
            nmr_processing_1.FiltersManager.applyFilter(datum, filters);
        }
    }
}
